/* eslint-disable */
/* tslint:disable */

import {
	EnumListResponse,
	Integer,
	OKIIEnumsNotSoSimpleResponse,
	OKIIStatusResponse,
	OrganizationObjectEnumResponse,
	String,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class KiiEnums<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Получение списка объектов КИИ связанных с крит БП (объектов перечня)
	 * @request GET:/kii_enums/{enum_list_id}/enum_objs
	 * @secure
	 */
	enumObjsDetail = (
		enumListId: number,
		query: {
			short_info: boolean;
			/** @format int32 */
			offset?: number;
			/** @format int32 */
			limit?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OKIIEnumsNotSoSimpleResponse[], void>({
			path: `/kii_enums/${enumListId}/enum_objs`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Получение списка объектов возможных к добавлению в перечень
	 * @request GET:/kii_enums/{org_id}/selection_list
	 * @secure
	 */
	selectionListDetail = (
		orgId: number,
		query?: {
			/**
			 * id перечня
			 * @format int32
			 */
			enumListId?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectEnumResponse[], void>({
			path: `/kii_enums/${orgId}/selection_list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Получение списка основных перечней для организации(но он должен быть один)
	 * @request GET:/kii_enums/{org_id}/main_enum_list
	 * @secure
	 */
	mainEnumListDetail = (orgId: number, params: RequestParams = {}) =>
		this.request<EnumListResponse[], void>({
			path: `/kii_enums/${orgId}/main_enum_list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Получение списка дополнений к перечню
	 * @request GET:/kii_enums/{org_id}/additional_enum_list
	 * @secure
	 */
	additionalEnumListDetail = (orgId: number, params: RequestParams = {}) =>
		this.request<EnumListResponse[], void>({
			path: `/kii_enums/${orgId}/additional_enum_list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Получение списка id всех перечный(основной перечень и дополнения к перечню)
	 * @request GET:/kii_enums/{org_id}/all_enum_list
	 * @secure
	 */
	allEnumListDetail = (orgId: number, params: RequestParams = {}) =>
		this.request<EnumListResponse[], void>({
			path: `/kii_enums/${orgId}/all_enum_list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Создание нового перечня по id организации (основной список, можно создать только 1)
	 * @request POST:/kii_enums/{org_id}/add_new_main_enum_list
	 * @secure
	 */
	addNewMainEnumListCreate = (orgId: number, data: String, params: RequestParams = {}) =>
		this.request<
			{
				id: number;
				listName: string;
				type: number;
				organization: number;
				creationDate: string;
				newestDocApprovalDate: any;
				uploaderName: string;
			},
			void
		>({
			path: `/kii_enums/${orgId}/add_new_main_enum_list`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Text,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Создание нового дополнения по id организации (дополнительный список)
	 * @request POST:/kii_enums/{org_id}/add_additional_enum_list
	 * @secure
	 */
	addAdditionalEnumListCreate = (orgId: number, data: String, params: RequestParams = {}) =>
		this.request<
			{
				id: number;
				listName: string;
				type: number;
				organization: number;
				creationDate: string;
				newestDocApprovalDate: any;
				uploaderName: string;
			},
			void
		>({
			path: `/kii_enums/${orgId}/add_additional_enum_list`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Text,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Добавление списка ОКИИ в перечень (по id перечня) по id объектов ОКИИ
	 * @request POST:/kii_enums/{enum_list_id}/add_objlist_to_enum_list
	 * @secure
	 */
	addObjlistToEnumListCreate = (enumListId: number, data: Integer[], params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/kii_enums/${enumListId}/add_objlist_to_enum_list`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Удалить переченя по ID перечня
	 * @request POST:/kii_enums/{enum_list_id}/delete_enum_list
	 * @secure
	 */
	deleteEnumListCreate = (enumListId: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/kii_enums/${enumListId}/delete_enum_list`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Удалить элемент перечня по ID элемента
	 * @request POST:/kii_enums/delete
	 * @secure
	 */
	deleteCreate = (data: Integer[], params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/kii_enums/delete`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Установить установить плановую дату
	 * @request POST:/kii_enums/{enum_obj_id}/{plan_date}/set_plan_date
	 * @secure
	 */
	setPlanDateCreate = (enumObjId: number, planDate: string, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/kii_enums/${enumObjId}/${planDate}/set_plan_date`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Изменение имени перечня
	 * @request POST:/kii_enums/{enum_list_id}/set_list_name
	 * @secure
	 */
	setListNameCreate = (enumListId: number, data: String, params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/kii_enums/${enumListId}/set_list_name`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Text,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Получение docx/pdf ссылки документа по его id
	 * @request GET:/kii_enums/docs/{doc_id}/{format}/link
	 * @secure
	 */
	docsLinkDetail = (docId: number, format?: string, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/kii_enums/docs/${docId}/${format}/link`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Выгрузка утвержденных документов
	 * @request POST:/kii_enums/docs/{doc_id}/upload
	 * @secure
	 */
	docsUploadCreate = (
		docId: number,
		data: {
			/** @format binary */
			ApprovedDoc?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<any, void>({
			path: `/kii_enums/docs/${docId}/upload`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Зафиксировать действие над объектом
	 * @request GET:/kii_enums/docs/{doc_id}/touch
	 * @secure
	 */
	docsTouchDetail = (
		docId: number,
		query: {
			/** действие (PRINT) */
			action: string;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/kii_enums/docs/${docId}/touch`,
			method: "GET",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Получение новейшего документа перечня (по id перечня)
	 * @request GET:/kii_enums/docs/{enum_list_id}/get_docx_ids
	 * @secure
	 */
	docsGetDocxIdsDetail = (enumListId: number, params: RequestParams = {}) =>
		this.request<Integer, void>({
			path: `/kii_enums/docs/${enumListId}/get_docx_ids`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Получение документа по его id
	 * @request GET:/kii_enums/docs/{doc_id}
	 * @secure
	 */
	docsDetail = (docId: number, params: RequestParams = {}) =>
		this.request<File, void>({
			path: `/kii_enums/docs/${docId}`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ
	 * @summary Проверка на наличие объектов повторного категорирования
	 * @request GET:/kii_enums/repeatable/{enum_list_id}/check
	 * @secure
	 */
	repeatableCheckDetail = (enumListId: number, params: RequestParams = {}) =>
		this.request<OKIIStatusResponse, void>({
			path: `/kii_enums/repeatable/${enumListId}/check`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
}
export const kiiEnumsAPI = new KiiEnums();
